export default __webpack_public_path__ + "static/slide3-9905faf146eb5bb15b800a9daea9cef1.webp";